import React,{ useState, useEffect, useRef } from 'react';
import { Col, Row } from 'antd';

import * as echarts from 'echarts/core';

import SixX from '../../image/6x.svg'

import './ChartBarDom.less'

const ChartBarDom = () =>{
  const chartRef = useRef(null);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    // const chart = echarts.init(chartRef.current);
    // setTimeout(()=>{
    //   let option = {
    //     title: {
    //       text: 'Urolithin A Glucoronide (ng/ml)',
    //       left: 'center',
    //       top: 'bottom'
    //     },
    //     tooltip: {
    //       trigger: 'axis',
    //       axisPointer: {
    //         type: 'shadow'
    //       }
    //     },
    //     grid: {
    //       top: 0,
    //       left: '3%',
    //       right: 10,
    //       bottom: '15%',
    //       containLabel: true
    //     },
    //     xAxis: {
    //       type: 'value',
    //       boundaryGap: [0, 0.01]
    //     },
    //     yAxis: {
    //       type: 'category',
    //       data: ['500mg Mitopure™', 'Diet only' ],
    //       axisLabel: {
    //         position: 'top'  // 将y轴文字设置在柱子上面
    //       }
    //     },
    //     series: [
    //       {
    //         name: '2011',
    //         type: 'bar',
    //         color: '#C23F3F',
    //         data: [470, 80],
    //         itemStyle: {
    //           borderRadius: [0, 5, 5, 0]
    //         },
    //         labelLayout(params) {
    //           return {
    //               x: params.rect.x + 10,
    //               y: params.rect.y + params.rect.height / 2,
    //               verticalAlign: 'middle',
    //               align: 'left'
    //           }
    //         }
    //       }
    //     ]
    //   };
    //   if(chartRef.current){
    //     chart.setOption(option);
    //   }
    // }, 100)
    
    const handleResize = () => {
      // chart.resize({
      //   width: 'auto',  // 宽度随着父容器变化而变化
      //   height: 'auto'  // 高度随着父容器变化而变化
      // });
      setWidth(window.innerWidth);
    };
 
    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);


 
    // 清理函数，组件卸载时移除监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  if(width>770){
    return (
      <div style={{width: '100%', maxWidth: 1440, margin: '0 auto', textAlign:'left'}}>
        <Row justify="space-between" style={{marginTop:40}}>
            <Col span={12} style={{fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)'}}>More Urolithin A than pomegranate juice**</Col>
            <Col span={10} style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'}}>
              Mitopure is the first and only clinically tested, highly pure Urolithin A postbiotic. Unlike dietary sources like pomegranate juice, Mitopure delivers efficacious levels of Urolithin A. Our clinical studies have shown 500mg Mitopure delivers 6X more Urolithin A than a glass of pomegranate juice**. 
              <span style={{borderBottom: '1px solid #000'}}>Read scientific evidence</span>
            </Col>
          </Row>

          <Row justify="space-between" style={{margin:'40px 0 200px'}}>
            <Col span={8}>
              <img style={{width:'100%'}} src={SixX} alt="" />
            </Col>
            
            <Col span={15}>
              {/* <div style={{width:'100%',height:'100%', minHeight: 250, marginTop: 75}} ref={chartRef}></div> */}
              <div style={{width:'100%',height:'100%', minHeight: 250, margin: '50px 0'}}>
                <div className="chart-bg">
                  <div className="axis-item">
                    <div className="line"></div>
                    <div className="num">0</div>
                  </div>
                  <div className="axis-item">
                    <div className="line"></div>
                    <div className="num">100</div>
                  </div>
                  <div className="axis-item">
                    <div className="line"></div>
                    <div className="num">200</div>
                  </div>
                  <div className="axis-item">
                    <div className="line"></div>
                    <div className="num">300</div>
                  </div>
                  <div className="axis-item">
                    <div className="line"></div>
                    <div className="num">400</div>
                  </div>
                  <div className="axis-item">
                    <div className="line"></div>
                    <div className="num">500</div>
                  </div>

                  <div className="chart-data-box">
                    <div className="chart-data">
                      Diet only
                      <div className="bar"></div>
                    </div>
                    <div className="chart-data">
                      500mg Mitopure™
                      <div className="bar"></div>
                    </div>
                  </div>
                </div>
                <div className="chart-title">Urolithin A Glucoronide (ng/ml)</div>
              </div>
            </Col>
          </Row>
      </div>
    )
  }else{
    return (
      <div style={{width: '100%', maxWidth: 1440, margin: '0 auto', padding: '0 25px', textAlign:'left'}}>
        <img style={{width:'60%'}} src={SixX} alt="" />
        <Row justify="space-between" style={{lineHeight:1.15}}>
          <Col span={24} style={{fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)'}}>More Urolithin A than pomegranate juice**</Col>
          <Col span={24} style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)', marginTop:20}}>
            Mitopure is the first and only clinically tested, highly pure Urolithin A postbiotic. Unlike dietary sources like pomegranate juice, Mitopure delivers efficacious levels of Urolithin A. Our clinical studies have shown 500mg Mitopure delivers 6X more Urolithin A than a glass of pomegranate juice**. 
            <span style={{borderBottom: '1px solid #000'}}>Read scientific evidence</span>
          </Col>
        </Row>

        <div style={{width:'100%',height:'100%', minHeight: 250, margin: '50px 0'}}>
          <div className="chart-bg">
            <div className="axis-item">
              <div className="line"></div>
              <div className="num">0</div>
            </div>
            <div className="axis-item">
              <div className="line"></div>
              <div className="num">100</div>
            </div>
            <div className="axis-item">
              <div className="line"></div>
              <div className="num">200</div>
            </div>
            <div className="axis-item">
              <div className="line"></div>
              <div className="num">300</div>
            </div>
            <div className="axis-item">
              <div className="line"></div>
              <div className="num">400</div>
            </div>
            <div className="axis-item">
              <div className="line"></div>
              <div className="num">500</div>
            </div>

            <div className="chart-data-box">
              <div className="chart-data">
                Diet only
                <div className="bar"></div>
              </div>
              <div className="chart-data">
                500mg Mitopure™
                <div className="bar"></div>
              </div>
            </div>
          </div>
          <div className="chart-title">Urolithin A Glucoronide (ng/ml)</div>
        </div>
      </div>
    )
  }
}

export default ChartBarDom